import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthWithScore = ({ children }) => {
  const navigate = useNavigate();
  const { score } = useSelector((state) => state.userSlice);

  useEffect(() => {
    // Only redirect if score is a real number equal to 0.
    // null means the score hasn't loaded yet (e.g. fresh msisdn login),
    // so we don't block in that case.
    if (score !== null && score === 0) {
      navigate("/home");
    }
  }, [score, navigate]);

  return <>{children}</>;
};

export default AuthWithScore;
